import React from "react";
import { Calendar as CalendarIcon, Star } from "lucide-react";
import { Button } from "../ui/button";

const safeScrollToId = (id) => {
    if (typeof document === "undefined") return;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
    return (
        <section
            id="hero"
            className="relative pt-16 pb-12 bg-white overflow-hidden isolate"
            aria-label="hero"
        >
            <div
                className="absolute left-0 bottom-[-2px] w-[80vh] ml-24 h-[60vh] bg-no-repeat bg-bottom bg-contain pointer-events-none"
                style={{ backgroundImage: "url('/image/svg/background.svg')" }}
            />

            <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

                <div className="pt-12 relative mx-auto order-1 md:order-2">
                    <div className="relative rounded-2xl">
                        <div className="absolute z-0 inset-0 bg-olive-50 rounded-2xl transform translate-x-4 translate-y-4" />
                        <img
                            src="/image/psiholog_2.jpg"
                            alt="cabinet"
                            className="w-96 object-cover rounded-2xl relative z-5"
                        />
                    </div>
                </div>

                <div className="order-2 md:order-1">
                    <h1 className="font-serif pt-12 text-3xl leading-snug text-olive-950 break-words">
                        Помогаю справляться
                    </h1>

                    <div className="mt-4 text-olive-900/70 text-sm max-w-prose space-y-3">
                        <p>
                            Я — Катерина Бондарева, практикующий клинический и кризисный психолог (БГУ, медицинская психология).
                        </p>
                        <p>Дополнительно окончила долгосрочные обучающие программы:</p>
                        <ul className="list-disc list-inside space-y-1">
                            <li>«Конструктивистский подход к оказанию психологической помощи» (нарративная практика и краткосрочная терапия, ориентированная на решение)</li>
                            <li>Международная аккредитованная программа КПТ+</li>
                            <li>Сертификационный курс по Схема-терапии</li>
                            <li>Специализированный курс в КПТ-подходе по работе с расстройствами личности</li>
                            <li>Программы по диалектико-бихевиоральной терапии (DBT), терапии принятия и ответственности (ACT), терапии, сфокусированной на самосострадании (CFT)</li>
                            <li>EMDR (десенсибилизация и переработка движениями глаз)</li>
                        </ul>
                        <p>
                            Специализируюсь на работе с возрастными и жизненными кризисами; имею опыт сопровождения во время горевания, утрат, травматических событий.
                        </p>
                        <p>
                            Работаю с вопросами самоопределения, утраты смысла жизни, одиночества, выбора жизненного пути, анализа и поиска человеком своего вектора; с запросами, связанными с тревожными и депрессивными состояниями, зависимостями.
                        </p>
                        <p>
                            В отдельном фокусе моих научных и практических интересов — комплексное посттравматическое стрессовое расстройство и расстройства личности.
                        </p>
                        <p>
                            Выступаю спикером на конференциях, занимаюсь научно-исследовательской деятельностью. В психологию пришла с многолетним опытом управленческой и предпринимательской деятельности. Буду рада помочь Вам стать автором собственной жизни.
                        </p>
                    </div>

                    <div className="mt-6 flex flex-wrap gap-3">
                        <Button
                            onClick={() => safeScrollToId("booking")}
                            className="bg-olive-50 text-olive-700 duration-300 hover:scale-105 border rounded-2xl hover:text-olive-900 hover:bg-olive-700"
                        >
                            <CalendarIcon className="w-4 h-4 mr-2" /> Записаться
                        </Button>
                    </div>

                    <div className="mt-6 flex items-center gap-6 text-olive-900/70 text-sm">
                        <div className="flex items-center gap-1">
                            {[...Array(5)].map((_, i) => (
                                <Star
                                    key={i}
                                    className="w-4 h-4 fill-olive-100 text-olive-100"
                                />
                            ))}
                        </div>
                        <span className="text-sm">5+ лет практики</span>
                    </div>
                </div>

            </div>
        </section>
    );
};
